<template>
  <v-card tile>
    <div id="centroNuevo">
      <v-toolbar card dark color="teal lighten-2">
        <v-toolbar-title v-if="mband==true">{{ minscur[0].nombrecurso }}  Horario: {{ minscur[0].fecha_inicio}} AL {{minscur[0].fecha_fin}} ({{minscur[0].hora_inicio}} A {{minscur[0].hora_fin}})</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-toolbar-items>
          <v-btn dark flat @click="$emit('close')">Cerrar</v-btn>
        </v-toolbar-items>
      </v-toolbar>
      <v-container grid-list-xl fluid>
        <v-layout row wrap>
        <v-flex xs12 >
          <h4 class="grey--text text--darken-1">
            <v-icon small color="primary">drag_indicator</v-icon> Participantes Inscritos
          </h4>
        </v-flex>
      </v-layout>
      <v-card>
        <v-card-title class="headline lighten-3">
          <v-text-field
            v-model="search"
            append-icon="search"
            label="Buscar"
            single-line
          >
          </v-text-field>
        </v-card-title>
        <v-data-table
            :headers="headers"
            :loading="loading"
            :items= "minscur" 
            class="elevation-1"
            rows-per-page-text="Filas por página"
            no-data-text="No existen registros"
            no-results-text="Sin resultados"
            page-text="de"
            :rows-per-page-items="[10, 25, 50, 100, {'text': 'Todos', value: -1}]"
            v-bind:search="search"
            v-cloak
          >
            <template v-slot:items="props">
              <td>{{ props.index + 1 }}</td>
              <td>{{ props.item.nombre }}</td>
              <td>{{ props.item.paterno }}</td>
              <td>{{ props.item.materno }}</td>
              <td>{{ props.item.carnet }}</td>
              <td>{{ props.item.fecha_registro | formatdate }}</td>
              <td>{{ props.item.correo }}</td>
              <td>{{ props.item.celular }}</td>
              <td>
                <span v-if="props.item.becario == true">SI</span>
                <span v-else-if="props.item.becario == false">NO</span>
              </td>
              <td>
                <v-tooltip bottom v-if="props.item.hoy <= props.item.limi">
                  <template v-slot:activator="{on}">
                    <v-btn
                      v-on="on"
                      dark
                      icon
                      small
                      depressed
                      color="red"
                      @click="confirmEliminado(props.item.id)"
                    >
                      <v-icon small>delete</v-icon>
                    </v-btn>
                  </template>
                  <span>Eliminar curso ofertado</span>
                </v-tooltip>
              </td>
            </template>
          </v-data-table>
      </v-card>
      </v-container>

      <v-dialog v-model="mconfirm" width="300">
      <v-card>
        <v-card-title class="headline grey lighten-3" primary-title>
          <span class="headline">Alerta</span>
        </v-card-title>
        <v-card-text class="text-xs-center">Esta seguro(a) de eliminar la inscripción?</v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="success darken-1" flat @click="deleteInscrip()">
            Aceptar
          </v-btn>
          <v-btn color="blue darken-1" flat @click="mconfirm = false">
            Cancelar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

      <v-snackbar v-model="snack.state" top right :timeout="2500" :color="snack.color"
        :multi-line="snack.mode === 'multi-line'">
        {{ snack.text }}
      </v-snackbar>
    </div>
  </v-card>
</template>
<script>
/* eslint-disable no-console */
import Service from "../services/general";
import axios from "axios";
export default {
  name: "detalle-inscritos",
  props: ['mcodigo2', 'minscur', 'mband', 'mloading'],
  data() {
    return {

      search: "",
      headers: [
        { text: 'Nro', align: 'left', sortable: false },
        { text: 'Nombre ', value: 'nombre' },
        { text: 'Paterno ', value: 'paterno' },
        { text: 'Materno ', value: 'materno' },
        { text: "Cédula ", value: "carnet" },
        { text: 'Fecha Inscripción ', value: 'fecha_inscripcion' },
        { text: 'Correo ', value: 'correo' },
        { text: 'Celular ', value: 'celular' },
        { text: 'Becario ', value: 'becario' },
        { text: 'Acción', sortable: false, width: '145px' }
       ],
      
      

      loading: false,
      color_txt: '',
      hide_accept: true,
      loadingBtnSend: false,

      participante: {
        id_curso: '',
        nombre: '',
        paterno: '',
        materno: '',
        cedula_identidad: '',
        complemento: '',
        expedido: '',
        fecha_nacimiento: '',
        genero_tipo_id: '',
        nombre_informe: ''
      },
      mconfirm: false,
      mensaje: '',
      dparams: {},
      snack: {
        state: false,
        color: 'success',
        mode: '',
        text: ''
      },
    };
  },
  mounted() {
    this.dparams = Service.getParams();
    if (this.dparams && this.dparams.roluser != Service.rol().director) {
      this.$router.push({ name: 'principal' });
    }
   
  },
  methods: {
    
    confirmEliminado(ins_id) {
      this.idborrar = ins_id;
      this.mconfirm = true;
    },
    deleteInscrip() { 
      axios
        .delete(Service.getBase() + 'elimina/inscripcion/' + this.idborrar, Service.getHeader())
        .then(() => {
          this.toast('success', 'Registro eliminado.');
          this.mconfirm = false;
          this.$router.go();  //refresca la pagina, cierra el modal y vuelve atras
          
        })
        .catch(error => {
          console.error('Error al eliminar', error);
        });

        
    },

    toast(color, text) {
      this.snack.color = color;
      this.snack.text = text;
      this.snack.state = true;
    },

  }
};
</script>